/* ==========================================================================
   GRAISE MED SPA - Theme JavaScript
   ========================================================================== */

(function() {
  'use strict';

  /* ---------- Mobile Menu ---------- */
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuClose = document.querySelector('[data-mobile-menu-close]');
  const menuOverlay = document.querySelector('[data-mobile-menu-overlay]');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (menuOverlay) menuOverlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (menuOverlay) menuOverlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    // Close all open submenus
    document.querySelectorAll('[data-mobile-submenu]').forEach(function(sub) {
      sub.classList.remove('is-open');
    });
    document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function() {
      var isOpen = mobileMenu && mobileMenu.classList.contains('is-open');
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  if (menuClose) {
    menuClose.addEventListener('click', closeMenu);
  }

  if (menuOverlay) {
    menuOverlay.addEventListener('click', closeMenu);
  }

  /* ---------- Mobile Submenu Toggles ---------- */
  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var parent = this.closest('.mobile-menu__item');
      var submenu = parent ? parent.querySelector('[data-mobile-submenu]') : null;
      if (!submenu) return;

      var isOpen = submenu.classList.contains('is-open');
      submenu.classList.toggle('is-open');
      this.setAttribute('aria-expanded', !isOpen);
    });
  });

  /* ---------- Close menu when any link inside it is clicked ---------- */
  document.querySelectorAll('.mobile-menu a[href]').forEach(function(link) {
    link.addEventListener('click', function() {
      closeMenu();
    });
  });

  /* ---------- Close menu on escape key ---------- */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
      closeMenu();
    }
  });

  /* ---------- Scroll Animations ---------- */
  var observerOptions = {
    root: null,
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.1
  };

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.fade-in').forEach(function(el) {
    observer.observe(el);
  });

  /* ---------- Accordion ---------- */
  document.querySelectorAll('.accordion__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var item = this.closest('.accordion__item');
      var isOpen = item.classList.contains('is-open');

      // Close all items in same accordion
      var accordion = item.closest('.accordion');
      if (accordion) {
        accordion.querySelectorAll('.accordion__item').forEach(function(i) {
          i.classList.remove('is-open');
        });
      }

      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });

  /* ---------- Before/After Slider ---------- */
  document.querySelectorAll('.ba-slider').forEach(function(slider) {
    var handle = slider.querySelector('.ba-slider__handle');
    var beforeEl = slider.querySelector('.ba-slider__before');
    var isDragging = false;

    function updateSlider(x) {
      var rect = slider.getBoundingClientRect();
      var percent = ((x - rect.left) / rect.width) * 100;
      percent = Math.max(0, Math.min(100, percent));
      handle.style.left = percent + '%';
      beforeEl.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
    }

    slider.addEventListener('mousedown', function(e) {
      isDragging = true;
      updateSlider(e.clientX);
    });

    document.addEventListener('mousemove', function(e) {
      if (isDragging) {
        updateSlider(e.clientX);
      }
    });

    document.addEventListener('mouseup', function() {
      isDragging = false;
    });

    slider.addEventListener('touchstart', function(e) {
      isDragging = true;
      updateSlider(e.touches[0].clientX);
    }, { passive: true });

    slider.addEventListener('touchmove', function(e) {
      if (isDragging) {
        e.preventDefault();
        updateSlider(e.touches[0].clientX);
      }
    }, { passive: false });

    slider.addEventListener('touchend', function() {
      isDragging = false;
    });
  });

  /* ---------- Product Quantity ---------- */
  document.querySelectorAll('.product-page__quantity').forEach(function(qty) {
    var input = qty.querySelector('.product-page__quantity-input');
    var minus = qty.querySelector('[data-qty-minus]');
    var plus = qty.querySelector('[data-qty-plus]');

    if (minus) {
      minus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
    }

    if (plus) {
      plus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  /* ---------- Product Image Gallery ---------- */
  document.querySelectorAll('.product-page__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = this.querySelector('img').getAttribute('src');
      var mainImage = this.closest('.product-page__gallery').querySelector('.product-page__main-image img');
      if (mainImage) {
        mainImage.setAttribute('src', src);
      }
      this.closest('.product-page__thumbnails').querySelectorAll('.product-page__thumb').forEach(function(t) {
        t.classList.remove('is-active');
      });
      this.classList.add('is-active');
    });
  });

  /* ---------- Header Scroll Behavior ---------- */
  var lastScroll = 0;
  var header = document.querySelector('.site-header');

  if (header) {
    window.addEventListener('scroll', function() {
      var currentScroll = window.pageYOffset;

      // Don't hide header if mobile menu is open
      if (mobileMenu && mobileMenu.classList.contains('is-open')) return;

      if (currentScroll > lastScroll && currentScroll > 100) {
        header.style.transform = 'translateY(-100%)';
      } else {
        header.style.transform = 'translateY(0)';
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ---------- Smooth Scroll for Anchor Links ---------- */
  document.querySelectorAll('[data-scroll-to]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var targetId = this.getAttribute('data-scroll-to');
      var target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

})();
